import Countdown from 'react-countdown';

const Timer = () => {
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <span>Launched!</span>;
        } else {
            // Render a countdown
            return <span>{days}d {hours}h {minutes < 10 ? '0' + minutes : minutes}m {seconds < 10 ? '0' + seconds : seconds}s</span>;
        }
    };
    const Completionist = () => <span></span>;
    return (
        <Countdown date={new Date("5-21-2022")} renderer={renderer} />
    )
}

export default Timer;